import { Component, NgZone } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from './services/analytics.service'
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router, NavigationStart, NavigationEnd } from '@angular/router';
import { environment } from '../environments/environment';
import { LeadService } from "./services/lead.service";
import { QuestionnaireService } from "./services/questionnaire.service";
import { Draft } from '../app/services/draft.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	closeResult: string;
	title = 'app';
	private route$: Subscription;
	appConfig = environment;


	private userAskOpenRegisterBio: boolean = false;

	constructor(
		translate: TranslateService,
		private analyticsService: AnalyticsService,
		private activeRoute: ActivatedRoute,
		private leadService: LeadService,
		private router: Router,
		private draftService: Draft,
		private questionnaireService: QuestionnaireService,
		private platformLocation: PlatformLocation,
		private ngZone: NgZone	
	) {
		translate.setDefaultLang('he');
		translate.use('he');

		this.setGA();


		//if(/[.]*dev/.test(window.location.search)){//has dev in querystring
		//this.setDev();
		//}
		this.questionnaireService.reset("1");

		history.pushState(null, '', window.location.href);

		this.platformLocation.onPopState(() => {
	
		  this.ngZone.run(() => {
			setTimeout(() =>{	
				this.restart();
				history.pushState(null, '', window.location.href);
			}, 10);
		  });
		});	 
	}

	restart(){
		let isAdvisor = this.questionnaireService.getIsAdvisor();
		this.draftService.isAfterStep1 = false;
		this.questionnaireService.setAsmachta("");
		this.draftService.clearBorrowersArr();
		this.questionnaireService.initData();
		if (isAdvisor) {
		  this.questionnaireService.reset("0");
		}
		else {
		  this.questionnaireService.reset("1");
		}
		this.router.navigate(["/"]);
	}

	ngOnInit() {
	}

	setGA() {
		// this.analyticsService.trackView();
		// this.route$ = this.activeRoute.params.subscribe(params => {

		// });

		this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: any) => {
			// see also 
			//console.log(val instanceof NavigationEnd) 
			//let path = event.url.split("/");
			//this.analyticsService.trackView(path[1],path[2],path[3]);	
			if (event.url) {
				this.analyticsService.trackView(event.url);
			}
			//console.log(">>> router.events:",val);
		});
	}

	sendFormTest() { //TODO: remove
		this.leadService.submitMashForm().subscribe(
			data => {
				console.log("send lead sucseed");
			});
	}

	setDev() {
		document.body.className = "dev"
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts